import React, { FC } from 'react';
import LoginForm from './components/login-form.component';
import LoginHeader from './components/login-header.component';
import CardContainer from 'shared/components/card/card.component';
import Page from 'components/page/page.component';
import SorensonLogin from 'utils/assets/images/sorenson-login-new.png';
import { Box } from '@mui/system';

const LoginPage: FC = () => {
  return (
    <Page pageTitle='Log In | VRS' showHeader={false} bgImage={SorensonLogin}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <CardContainer>
          <LoginHeader />
          <LoginForm />
        </CardContainer>
      </Box>
    </Page>
  );
};

export default LoginPage;
